import React, { useState } from "react";
import StepNavigation from "../../components/addListing/StepNavigation";
import { useTranslation } from "react-i18next";
import "../../styles/steps.css";

const CATEGORY_GROUPS = {
  construction_foundation: [
    "blocks_bricks",
    "cement",
    "sand",
    "gravel",
    "concrete",
    "rebar_metal",
    "metal_mesh",
    "pipes",
    "waterproofing",
    "thermal_insulation",
    "sound_insulation",
    "roofing",
    "gutters",
    "sandwich_panels",
  ],

  preparation_rough_construction: [
    "drywall_gypsum_board",
    "metal_profiles",
    "putty",
    "plaster",
    "primers",
    "self_leveling_floors",
    "tile_adhesive",
    "insulation_adhesive",
    "construction_chemicals",
    "accessories",
  ],

  engineering_utilities: [
    "electrical",
    "cables",
    "switches",
    "sockets",
    "breakers",
    "electrical_boxes",
    "conduits",
    "plumbing",
    "water_pipes",
    "sewer_pipes",
    "fittings",
    "collectors",
    "faucets",
    "heating",
    "radiators",
    "heating_pipes",
    "heating_equipment",
    "ventilation",
    "ducts",
    "grilles",
    "fans",
  ],

  finishing_interior: [
    "tiles",
    "porcelain_ceramic_tiles",
    "laminate",
    "parquet",
    "linoleum",
    "wallpaper",
    "paint",
    "decorative_plaster",
    "doors",
    "windows",
    "bathroom_fixtures",
    "bathtubs",
    "showers",
    "toilets",
    "sinks",
    "lighting",
  ],
};

export default function StepRenovationType({
  listing,
  setListing,
  onNext,
}) {
  const { t } = useTranslation();

  const [openOther, setOpenOther] = useState(false);

  const selectedGroups = listing.categoryGroups || [];
  const selectedCategories = listing.categories || [];

  /* =========================
     GROUP
  ========================== */

  const toggleGroup = (group) => {
    setListing((prev) => {
      const groups = prev.categoryGroups || [];
      const exists = groups.includes(group);

      return {
        ...prev,
        categoryGroups: exists
          ? groups.filter((g) => g !== group)
          : [...groups, group],
      };
    });
  };

  /* =========================
     CATEGORY
  ========================== */

  const toggleCategory = (category) => {
    setListing((prev) => {
      const categories = prev.categories || [];
      const exists = categories.includes(category);

      return {
        ...prev,
        categories: exists
          ? categories.filter((c) => c !== category)
          : [...categories, category],
      };
    });
  };

  /* =========================
     OTHER
  ========================== */

  const handleOtherChange = (e) => {
    const value = e.target.value;

    setListing((prev) => ({
      ...prev,
      otherCategory: value,
    }));
  };

  /* =========================
     NEXT
  ========================== */

  const isNextDisabled =
    selectedGroups.length === 0;

  return (
    <div className="step">

      <h2 className="step-title">
        {t("renovation.stepTypeTitle")}
      </h2>

      <p className="step-description">
        {t("renovation.stepTypeDescription")}
      </p>

      {/* =========================
          GROUPS
      ========================== */}

      <div className="option-grid">

        {Object.keys(CATEGORY_GROUPS).map((group) => {

          const selected =
            selectedGroups.includes(group);

          return (
            <button
              key={group}
              type="button"
              className={`option-card ${
                selected ? "active" : ""
              }`}
              onClick={() => toggleGroup(group)}
            >
              {t(`renovation.groups.${group}`)}

              {selected && (
                <span> ✓</span>
              )}
            </button>
          );
        })}

      </div>

      {/* =========================
          SELECTED GROUP CATEGORIES
      ========================== */}

      {selectedGroups.map((group) => {

        const categories =
          CATEGORY_GROUPS[group] || [];

        return (
          <div
            key={group}
            className="renovation-step-group"
          >

            <h3 className="step-subtitle">
              {t(`renovation.groups.${group}`)}
            </h3>

            <div className="option-grid small">

              {categories.map((category) => {

                const selected =
                  selectedCategories.includes(category);

                return (
                  <button
                    key={category}
                    type="button"
                    className={`option-card ${
                      selected ? "active" : ""
                    }`}
                    onClick={() =>
                      toggleCategory(category)
                    }
                  >
                    {t(
                      `renovation.categories.${category}`
                    )}

                    {selected && (
                      <span> ✓</span>
                    )}
                  </button>
                );
              })}

              {/* =========================
                  OTHER
              ========================== */}

              <button
                type="button"
                className={`option-card ${
                  openOther ? "active" : ""
                }`}
                onClick={() =>
                  setOpenOther((prev) => !prev)
                }
              >
                {t("renovation.other")}

                {openOther && (
                  <span> ✓</span>
                )}
              </button>

            </div>

          </div>
        );
      })}

      {/* =========================
          OTHER INPUT
      ========================== */}

      {openOther && (
        <div className="renovation-other-input">

          <label className="form-label">
            {t("renovation.otherSpecify")}
          </label>

          <input
            type="text"
            value={listing.otherCategory || ""}
            onChange={handleOtherChange}
            placeholder={t(
              "renovation.otherPlaceholder"
            )}
            className="form-input"
          />

        </div>
      )}

      {/* =========================
          NAVIGATION
      ========================== */}

      <StepNavigation
        onNext={onNext}
        nextDisabled={isNextDisabled}
      />

    </div>
  );
}
